import { useState } from "react";
import jsPDF from "jspdf";

const dtgPriceTable = {
  white: {
    "Left Chest 5x5": [6.00, 5.50, 5.00, 5.00],
    "Up to 12x12": [7.50, 7.00, 6.50, 6.00],
    "12x15 Over Size": [9.00, 8.50, 8.00, 7.50],
    "15x19.5 Max Print": [12.00, 11.50, 11.25, 10.50],
  },
  dark: {
    "Left Chest 5x5": [8.00, 7.50, 7.00, 6.00],
    "Up to 12x12": [8.00, 7.50, 7.00, 6.00],
    "12x15 Over Size": [10.50, 10.00, 9.50, 9.00],
    "15x19.5 Max Print": [13.50, 13.00, 12.75, 12.50],
  },
};

const quantityRanges = [12, 25, 49, 149];

export default function DtgCalci() {
  const [blankCost, setBlankCost] = useState("");
  const [quantity, setQuantity] = useState("");
  const [garmentType, setGarmentType] = useState("white");
  const [printSize, setPrintSize] = useState("Left Chest 5x5");
  const [hoodie, setHoodie] = useState(false);
  const [profitMargin, setProfitMargin] = useState(0.25);
  const [customMargin, setCustomMargin] = useState("");
  const [totalPrice, setTotalPrice] = useState(null);
  const [perItemCost, setPerItemCost] = useState(null);

  const getDTGPrice = (qty) => {
    let rangeIndex = 0;
    for (let i = 0; i < quantityRanges.length; i++) {
      if (qty >= quantityRanges[i]) {
        rangeIndex = i;
      }
    }
    return dtgPriceTable[garmentType][printSize][rangeIndex] || 0;
  };

  const handleCalculate = () => {
    const qty = parseFloat(quantity) || 0;
    const blank = parseFloat(blankCost) || 0;
    const actualMargin = customMargin !== "" ? parseFloat(customMargin) / 100 : profitMargin;

    const basePrintCost = getDTGPrice(qty);
    const hoodieCost = hoodie ? 1 : 0;
    const basePrice = (blank + basePrintCost + hoodieCost) * qty;
    const finalPrice = basePrice * (1 + actualMargin);
    setTotalPrice(finalPrice.toFixed(2));

    if (qty > 0) {
      setPerItemCost((finalPrice / qty).toFixed(2));
    } else {
      setPerItemCost(null);
    }
  };

  const handleDownloadPDF = () => {
    const doc = new jsPDF();
    doc.text("DTG Printing Price Calculator", 10, 10);
    doc.text(`Blank Cost: $${blankCost}`, 10, 20);
    doc.text(`Quantity: ${quantity}`, 10, 30);
    doc.text(`Garment Type: ${garmentType === "white" ? "White Shirt" : "Dark Garment"}`, 10, 40);
    doc.text(`Print Size: ${printSize}`, 10, 50);
    doc.text(`Hoodie/Crew Neck: ${hoodie ? "Yes (+$1)" : "No"}`, 10, 60);
    doc.text(`Profit Margin: ${profitMargin === -1 ? customMargin + "%" : profitMargin * 100 + "%"}`, 10, 70);
    if (totalPrice) {
      doc.text(`Total Price: $${totalPrice}`, 10, 80);
      doc.text(`Per Item Cost: $${perItemCost}`, 10, 90);
    }
    doc.save("dtg_printing_quote.pdf");
  };

  return (
    <div className="container" style={{
      maxWidth: 600,
      margin: "0 auto",
      paddingTop: 30,
      paddingBottom: 50,
      backgroundColor: "#f9f9f9",
      borderRadius: 8,
      boxShadow: "0 4px 8px rgba(0,0,0,0.1)"
    }}>
      <h1 className="text-3xl font-bold mb-4 text-center">DTG Printing Calculator</h1>

      <div className="form-group mb-3">
        <label>Blank Cost ($):</label>
        <input type="number" step="0.01" className="form-control" value={blankCost} onChange={(e) => setBlankCost(e.target.value)} />
      </div>

      <div className="form-group mb-3">
        <label>Quantity:</label>
        <input type="number" step="0.01" className="form-control" value={quantity} onChange={(e) => setQuantity(e.target.value)} />
      </div>

      <div className="form-group mb-3">
        <label>Garment Type:</label>
        <select className="form-control" value={garmentType} onChange={(e) => setGarmentType(e.target.value)}>
          <option value="white">White Shirt (No Underbase)</option>
          <option value="dark">Dark Garment (With Underbase)</option>
        </select>
      </div>

      <div className="form-group mb-3">
        <label>Print Size:</label>
        <select className="form-control" value={printSize} onChange={(e) => setPrintSize(e.target.value)}>
          <option value="Left Chest 5x5">Left Chest 5x5</option>
          <option value="Up to 12x12">Up to 12" x 12"</option>
          <option value="12x15 Over Size">12" x 15" Over Size</option>
          <option value="15x19.5 Max Print">15" x 19.5" Max Print</option>
        </select>
      </div>

      <div className="form-group mb-3">
        <label>
          <input type="checkbox" checked={hoodie} onChange={() => setHoodie(!hoodie)} /> Hoodie or Crew Neck (+$1)
        </label>
      </div>

      <div className="form-group mb-3">
        <label>Profit Margin:</label>
        <select className="form-control" value={profitMargin} onChange={(e) => setProfitMargin(parseFloat(e.target.value))}>
          <option value={0.25}>25%</option>
          <option value={0.35}>35%</option>
          <option value={0.45}>45%</option>
          <option value={0.5}>50%</option>
          <option value={-1}>Custom</option>
        </select>
      </div>

      {profitMargin === -1 && (
        <div className="form-group mb-3">
          <label>Custom Margin (%):</label>
          <input type="number" step="0.01" className="form-control" value={customMargin} onChange={(e) => setCustomMargin(e.target.value)} />
        </div>
      )}

      <div className="text-center mb-4">
        <button className="btn btn-primary btn-lg" onClick={handleCalculate}>
          Calculate Price
        </button>
      </div>

      {totalPrice && (
        <div className="alert alert-success text-center">
          <h4>Total Price: ${totalPrice}</h4>
          <h5>Per Item Cost: ${perItemCost}</h5>
        </div>
      )}

      {totalPrice && (
        <div className="text-center">
          <button className="btn btn-success" onClick={handleDownloadPDF}>
            Download PDF Quote
          </button>
        </div>
      )}
    </div>
  );
}
